import type LifeHiringInsured from '../../models/APP/LifeHiringInsured'
import BENEFICIARY_TYPES from '@/modules/life/hiring/constants/BeneficiaryTypes'

export default class SaveBeneficiariesMapper {
  static toRequest(quotationId: string, insured: LifeHiringInsured) {
    return {
      quotationId,
      policyHolderConsent: true,
      beneficiaries: insured.beneficiaries.map((b) => {
        const beneficiaryData: any = {
          riskNumber: b.riskNumber,
          beneficiaryType: b.beneficiaryType,
          beneficiaryRiskNumber: b.beneficiaryRiskNumber,
          name: b.name || undefined,
          firstSurname: b.firstSurname || undefined,
          secondSurname: b.secondSurname || undefined,
          distributionPercentage: b.distributionPercentage || undefined
        };

        // Solo incluir documentType si el tipo de beneficiario es CUSTOM
        if (b.beneficiaryType === BENEFICIARY_TYPES.CUSTOM) {
          beneficiaryData.documentType = b.documentType || undefined;
          beneficiaryData.documentNumber = b.documentNumber || undefined;
        }

        return beneficiaryData;
      }),
      mortgageClauses: insured.mortgageClauses
    };
  }
}